<template>
  <fn-section
    constrained="l"
    background-color="sand-light"
    padding-top="xs"
    padding-bottom="m"
    class="newsletter-confirmation-section"
  >
    <fn-panel-image
      image-hide-mobile
      column-size="6"
    >
      <template
        v-if="image"
        #image
      >
        <fn-picture
          :src="image.src"
          :width="image.width"
          :height="image.height"
        />
      </template>
      <template #default>
        <fn-headline type="h2">
          {{ $t('newsletter.registerConfirmation.headline', { salutation: recipientName }) }}
        </fn-headline>

        <fn-paragraph v-html="$t('newsletter.registerConfirmation.confirmationText')" />

        <fn-list
          background-color="orange"
          foreground-color="white"
          unstyled
          icons
          colored
        >
          <li v-if="newsletter?.address">
            <fn-icon
              icon="email"
              size="xs"
            />
            <span>
              {{ newsletter.address.emailAddress }}
            </span>
          </li>
          <li>
            <fn-icon
              icon="paw"
              size="xs"
            />
            <span v-html="$t('newsletter.registerConfirmation.activationText')" />
          </li>
          <li v-if="showRaffleText">
            <fn-icon
              icon="check"
              size="xs"
            />
            <span v-html="$t('newsletter.registerConfirmation.raffleText')" />
          </li>
        </fn-list>
      </template>
    </fn-panel-image>
  </fn-section>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      required: true,
    },
    newsletter: {
      type: Object,
      default: () => {},
    },
    showRaffleText: {
      type: Boolean,
    },
  },
  computed: {
    recipientName() {
      if (this.newsletter?.recipient?.lastname) {
        return `, ${this.newsletter.recipient.firstname} ${this.newsletter.recipient.lastname}`;
      }
      return this.$t('newsletter.registerConfirmation.fallback');
    },
  },
};
</script>
